<template>
  <b-modal
    :title="`Archivar Expediente ${processedFile.numero}`"
    v-model="showModal"
    centered
    hide-footer
  >
    <div>
      Al dar por archivado este documento, no podrás actuar sobre él, ¿estás de acuerdo?
    </div>
    <div class="chip-custom">
      ¡Al realizar esta acción se marcará
      como archivado el expediente para todos los participantes
       y no se podrán hacer mas acciones sobre éste!
      <br>
      <b>Esta acción no tiene vuelta atrás.</b>
    </div>
    <div class="wrap-commentary">
      <vs-textarea
        data-cy="write-comment"
        maxlength="255"
        label="Comentario"
        v-model="comment"
      />
      <div v-if="notValid">
        <small style="color: red;">
          No has ingresado un comentario para validar esta acción
        </small>
      </div>
    </div>
    <div class="m-top-20" style="display: flex;justify-content: flex-end;">
      <vs-button
      data-cy="cancel"
      color="dark"
      v-on:click="cancelProcess()"
      type="border">Cancelar
      </vs-button>
      <vs-button
        data-cy="yes-archive"
        v-on:click="processFile()"
        color="primary"
        style="margin-left: 12px;"
        type="border"
      >
        Si, archivar
      </vs-button>
    </div>
  </b-modal>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import FiltersDntMixin from '@/febos/chile/dnt/mixins/FiltersDntMixin';

export default {
  name: 'PopUpArchiveFile',
  mixins: [FiltersDntMixin],
  data() {
    return {
      comment: '',
      notValid: false
    };
  },
  props: {
    processedFile: {
      type: [Object],
      required: true,
      default: () => {}
    }
  },
  watch: {
    comment() {
      this.notValid = false;
    },
    processedFile() {
      this.notValid = false;
      this.comment = '';
    }
  },
  computed: {
    ...mapGetters('Modals', [
      'modalName'
    ]),
    showModal: {
      get() {
        return this.modalName === 'archiveFile';
      },
      set() {
        this.closeModal();
      }
    }
  },
  methods: {
    ...mapActions('Dnts', [
      'archiveDntFileED'
    ]),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    async processFile() {
      this.notValid = false;
      if (this.comment === '') {
        this.notValid = true;
        return;
      }
      const toProcess = {
        febosId: this.processedFile.febosId,
        estadoId: '100',
        comentario: this.comment
      };
      await this.archiveDntFileED(toProcess);
    },
    cancelProcess() {
      this.notValid = false;
      this.closeModal();
    }
  }
};
</script>
<style scoped>
.chip-custom {
  font-size: 12px;
  margin-top: 10px;
  color: #ffb300;
  background: #fff5df;
  border-radius: 10px;
  padding: 4px 8px;
}
.wrap-commentary {
  width: 90%;
  margin: 20px auto;
}
</style>
